import { useMemo, useCallback } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import useResponsiveFontSize from './useResponsiveFontSize';
import { dispatch } from 'store';
import { createCreditCardInfo } from 'modules/user/actions';
import texts from './texts';
import { t } from 'utils';

const useOptions = () => {
  const fontSize = useResponsiveFontSize();
  const options = useMemo(
    () => ({
      hidePostalCode: true,
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [fontSize],
  );

  return options;
};

export const CardForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }

      const payload = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
      });

      if (payload && payload?.paymentMethod?.id) {
        dispatch(createCreditCardInfo.request(payload.paymentMethod.id));
      }
    },
    [dispatch, stripe, elements],
  );

  return (
    <form
      onSubmit={handleSubmit}
      style={{ width: '100%', padding: '20px', backgroundColor: '#fff' }}
    >
      <label>
        <p style={{ marginBottom: '10px', marginTop: 0 }}>{t(texts.plan.cardDetails)}</p>
        <CardElement
          options={options}
          onReady={() => {
            // console.log('CardElement [ready]');
          }}
          onChange={event => {
            // console.log('CardElement [change]', event);
          }}
          onBlur={() => {
            // console.log('CardElement [blur]');
          }}
          onFocus={() => {
            // console.log('CardElement [focus]');
          }}
        />
      </label>
      <button style={{ marginTop: '10px' }} type="submit" disabled={!stripe}>
        {t(texts.plan.addCard)}
      </button>
    </form>
  );
};
